import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

export const MainBlock = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  padding: 24px;
  background-color: white;

  @media (max-width: 768px) {
    padding: 16px 12px;
    gap: 12px;
  }
`;

export const PlansList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    flex-wrap: nowrap;
  }
`;

export const disableButtonCSS = css`
  outline: unset !important;
  border-width: 0;

  &:disabled {
    background-color: ${theme.colors.DisabledInputColor} !important;
    border: 1px ${theme.colors.DisabledInputColor} !important;
    outline: 1px ${theme.colors.DisabledInputColor} !important;
    color: ${theme.colors.Gray} !important;
  }
`;

export const modalContainerCss = css`
  padding: 34px 24px;
  width: 500px;
  max-width: 500px;

  @media (max-width: 768px) {
    width: calc(100vw - 24px);
    max-width: none;
    padding: 20px 12px;
  }
`;

export const Button = styled.button`
  cursor: pointer;
  background: ${theme.colors.SurfaceWhite};

  width: 140px;
  height: 36px;
  padding: 8px 16px 8px 16px;
  gap: 10px;
  border-radius: 8px;
  border: 1px;

  font-family:
    SF Pro Display,
    sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;

  &:hover {
    background: ${theme.colors.AccentCornsilk};
  }

  &:active {
    background: ${theme.colors.AccentNaplesYellow};
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;
